module.exports = __webpack_public_path__ + "img/brightscreen_1000.2b565766.png";